import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ContractRefundPayment.Cancel.IRequest;
type Response = Api.Finance.ContractRefundPayment.Cancel.IResponse;
type Headers = Api.Finance.ContractRefundPayment.Cancel.IHeaders;
const url = '/api/Finance/ContractRefundPayment/:id/Cancel';
export default async function contractRefundPaymentCancelApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
